import script from "./OrderInformationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInformationCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderInformationCard.vue?vue&type=style&index=0&id=20bdb2df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bdb2df"]])

export default __exports__